export default __webpack_public_path__ + "static/media/wallet-product-lending.f597f0b1.svg";